import { render, staticRenderFns } from "./DocsH3.vue?vue&type=template&id=6942451c&scoped=true&"
import script from "./DocsH3.vue?vue&type=script&lang=js&"
export * from "./DocsH3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942451c",
  null
  
)

export default component.exports